import { all, put, call, takeEvery, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load division
function* beginingStockLoadDivision(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      plant_id,
      accessToken,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/load-division`,
      { location_visibility, division_id, department_id, section_id, plant_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadDivision.failure())
  }
}

// *load department
function* beginingStockLoadDepartment(action) {
  const {
    data: { location_visibility, division_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/load-department`,
      { location_visibility, division_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadDepartment.failure())
  }
}

// *load section
function* beginingStockLoadSection(action) {
  const {
    data: { location_visibility, division_id, department_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/load-section`,
      { location_visibility, division_id, department_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadSection.failure())
  }
}

// *load plant
function* beginingStockLoadPlant(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/load-plant`,
      { location_visibility, division_id, department_id, section_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadPlant.failure())
  }
}

// *load data source for table
function* beginingStockLoadDataSourceForTable(action) {
  const {
    data: {
      plant_id,
      stock_date,
      accessToken,
      location_visibility,
      material_visibility,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/get-begining-stock`,
      {
        filterObj: {
          plant_id,
          stock_date,
        },
        location_visibility,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadDataSourceForTable.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadDataSourceForTable.failure())
  }
}

// *update data source for table
function* beginingStockUpdateDataSourceForTable(action) {
  const {
    data: { dataSource, location_visibility, material_visibility, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/update-begining-stock`,
      {
        dataSource,
        location_visibility,
        material_visibility,
        matching_name: 'begining-stock',
        action_name: 'edit',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockUpdateDataSourceForTable.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockUpdateDataSourceForTable.failure())
  }
}

// *load error
function* beginingStockLoadError(action) {
  const {
    data: { plant_id, stock_date, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/begining-stock/get-error-data-sending-to-bluenet`,
      {
        plant_id,
        stock_date,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockLoadError.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockLoadError.failure())
  }
}

// *export 1 form ประเมินคุณภาพ
function* beginingStockExport(action) {
  const {
    data: { plant_id_list, start_date, end_date, type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_CPAC_ISUPPLY_REPORT_GO}/export-begining-stock`,
      { plant_id_list, start_date, end_date, type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.beginingStockExport.success(res.data))

    if (res.data.result === null) {
      return
    }

    window.location = res.data.result
  } catch (err) {
    console.log(err.message)
    yield put(actions.beginingStockExport.failure())
  }
}

export default function* watchBeginingStock() {
  yield all([
    takeLatest(
      actions.BEGINING_STOCK_LOAD_DIVISION.REQUEST,
      beginingStockLoadDivision
    ),
    takeLatest(
      actions.BEGINING_STOCK_LOAD_DEPARTMENT.REQUEST,
      beginingStockLoadDepartment
    ),
    takeLatest(
      actions.BEGINING_STOCK_LOAD_SECTION.REQUEST,
      beginingStockLoadSection
    ),
    takeLatest(
      actions.BEGINING_STOCK_LOAD_PLANT.REQUEST,
      beginingStockLoadPlant
    ),
    takeLatest(
      actions.BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.REQUEST,
      beginingStockLoadDataSourceForTable
    ),
    takeEvery(
      actions.UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.REQUEST,
      beginingStockUpdateDataSourceForTable
    ),
    takeLatest(
      actions.BEGINING_STOCK_LOAD_ERROR.REQUEST,
      beginingStockLoadError
    ),
    takeEvery(actions.BEGINNING_STOCK_EXPORT.REQUEST, beginingStockExport),
  ])
}

export {
  beginingStockLoadDivision,
  beginingStockLoadDepartment,
  beginingStockLoadSection,
  beginingStockLoadPlant,
  beginingStockLoadDataSourceForTable,
  beginingStockUpdateDataSourceForTable,
  beginingStockLoadError,
  beginingStockExport,
}
